import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): Observable<boolean> {
    const data = localStorage.getItem('usuario');
    
    if (!data) {
      // Se não há usuário logado, redireciona para login
      this.router.navigate(['/pages/usuarios/autenticar']);
      return of(false);
    }

    try {
      const usuario = JSON.parse(data);
      const role = usuario?.role?.trim() || usuario?.usuario?.role?.trim() || '';

      // Verifica se o role NÃO é "Colaborador"
      if (role.toLowerCase() !== 'colaborador') {
        return of(true); // Permite acesso
      } else {
        // Se for colaborador, mostra mensagem e volta para página anterior
        Swal.fire({
          title: 'Acesso Negado',
          text: 'Você não tem permissão para acessar esta área. Esta seção é restrita apenas para administradores.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#dc3545'
        }).then(() => {
          // Volta para a página anterior
          window.history.back();
        });
        return of(false);
      }
    } catch (error) {
      console.error('Erro ao verificar permissões:', error);
      Swal.fire({
        title: 'Erro de Autenticação',
        text: 'Erro ao verificar suas permissões. Faça login novamente.',
        icon: 'error',
        confirmButtonText: 'OK'
      }).then(() => {
        this.router.navigate(['/pages/usuarios/autenticar']);
      });
      return of(false);
    }
  }
}
